import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Card, CardBody, Row, Col } from "reactstrap"
import { AvField, AvForm } from "availity-reactstrap-validation"
 import FileUpload from "components/Common/file-upload/file-upload.component"
import { providerPrefix } from "configs/routePrefix"
import { toast } from "react-toastify"
import { SuccessOk } from "configs/statusCode"
import CancelModal from "components/CancelModal"
import LeadService from "services/Provider/LeadService"
import SelectOptions from "components/SelectOptions"
 import SalesRepsService from "services/Admin/SalesRepsService"

const initialState = {
    name: "",
    email: "",
    phone: "",
    address: "",
    sales_rep_id: null,
    
}

const UpdateDeveloperPage = (props) => {
    const [loading, setLoading] = useState(false)
    const [formState, setFormState] = useState(initialState)
    const [modal, setModal] = useState(false)
    const [salesRepOptions, setSalesRepOptions] = useState([])
    const leadService = new LeadService()

  
    const handleFieldChange = (e) => {
        setFormState({ ...formState, [e.target.name]: e.target.value })
    }

    const handleValidSubmit = (e, v) => {
        if(!formState.sales_rep_id){
            toast.error("Please select sales rep")
            return
        }else{
            setLoading(true)
            const data = {
                ...formState,
               sales_rep_id: formState.sales_rep_id.value,
           }
   
           leadService.create(data).then(response=>{
                if(response && response.status===SuccessCreated){
                   toast.success("Lead added Successfully")
                   props.history.goBack()
               }
           })
        }
       
    }

    return (
        <React.Fragment>
            <div className='page-content'>
                <MetaTags>
                    <title>Add Lead</title>
                </MetaTags>
                <Container fluid>
                    <h4>
                        <button className="p-0 m-0 border-0 bg-light"
              onClick={() => {
                 props.history.push(`${providerPrefix}/leads`)
              }}>
              <i className="fa fa-arrow-left text-primary me-2"></i>
            </button>
                        Add Lead
          </h4>
                    <AvForm
                        className='form-horizontal'
                        onValidSubmit={(e, v) => {
                            handleValidSubmit(e, v)
                        }}>
                        <Card className="w-100 mt-4">
                            <CardBody>
                                <Row className="mb-4">
                                    <Col md={6}>
                                        <div className='mb-3'>
                                            <AvField
                                                name='name'
                                                label="Name"
                                                className='form-control'
                                                placeholder='Type Name'
                                                required
                                                onChange={(e) => handleFieldChange(e)}
                                                bsSize="lg"
                                                value={formState.name}
                                            />
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className='mb-3'>
                                            <AvField
                                                name='phone'
                                                placeholder={"123456789"}
                                                label="Phone"
                                                className='form-control'
                                                required
                                                onChange={(e) => handleFieldChange(e)}
                                                bsSize="lg"
                                                type="number"
                                                value={formState.phone}
                                            />
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className='mb-3'>
                                            <AvField
                                                name='email'
                                                label="Email"
                                                className='form-control'
                                                placeholder='lead@gmail.com'
                                                required={false}
                                                type="text"
                                                onChange={(e) => handleFieldChange(e)}
                                                bsSize="lg"
                                                value={formState.email}
                                            />
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <SelectOptions
                                            label='Sales Rep (Sales Owner)'
                                            placeholder='Select'
                                            options={salesRepOptions}
                                            handleSelectChange={(data) => {
                                                setFormState({ ...formState, sales_rep_id: data });
                                            }}
                                            selectedOption={formState.sales_rep_id}
                                            Service={SalesRepsService}
                                            setOptions={(options) => {
                                                setSalesRepOptions(options)
                                            }}
                                        />
                                    </Col>
                                    <Col md={12}>
                                        <div className='mb-3'>
                                            <AvField
                                                name='address'
                                                label="Address"
                                                placeholder='Type Address'
                                                className='form-control'
                                                type="text"
                                                onChange={(e) => handleFieldChange(e)}
                                                bsSize="lg"
                                                value={formState.address}
                                            />
                                        </div>
                                    </Col>
                                    
                                </Row>
                            </CardBody>
                        </Card>
                        <Row className="d-flex justify-content-between pb-4">
                            <Col>
                                <button
                                    type="button"
                                    className="btn btnUpload btnHeight px-4"
                                    onClick={() => {
                                        setModal(true)
                                    }}
                                    size={"lg"}>
                                    Cancel
                  </button>
                            </Col>
                            <Col>
                                <button
                                    type='submit'
                                    className="btn btn-success btnHeight px-4 float-end"
                                    size={"lg"}
                                    disabled={loading ? true :false}

                                >
                                    Submit
                </button>
                            </Col>
                        </Row>
                        <CancelModal modal={modal}
                            setModal={setModal}
                            goBackHandler={() => props.history.push(`${providerPrefix}/leads`)}
                        />
                    </AvForm>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default UpdateDeveloperPage
